
const digest = '78ff3cc1c27a5c8121342ceef5370de3eb46fa0369595aed894c572b62c10954';
const classes = {"wrapper":"_wrapper_mzynv_1","table":"_table_mzynv_8"};
const css = `._wrapper_mzynv_1 {
  background-color: #ffffff;
  border: 1px solid #eaedf3;
  font-family: Rubik, sans-serif;
  height: 100%;
  overflow-y: auto;
}
._wrapper_mzynv_1 ._table_mzynv_8 {
  width: 100%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  